import { useTranslation } from 'react-i18next'

import { RESULT_REQUEST } from 'features/close-circle-edit/close-circle-edit'

import error_icon from 'shared/images/error.png'
import success_icon from 'shared/images/success_popup.png'
import { PopupContent } from 'shared/ui/poup-content'

type Props = {
  result: RESULT_REQUEST
  onNavigate: () => void
}
export const SuccessEditModal = ({ result, onNavigate }: Props) => {
  const { t } = useTranslation()
  return (
    <PopupContent
      image={result === RESULT_REQUEST.SUCCESS ? success_icon : error_icon}
      title={
        result === RESULT_REQUEST.SUCCESS
          ? t('edit_profile.success')
          : t('error_popup')
      }
      description={
        result === RESULT_REQUEST.SUCCESS
          ? t('edit_profile.success_description')
          : t('error_popup_description')
      }
      button={t('apply')}
      onClick={onNavigate}
    />
  )
}
